import z from "zod";
import { cs } from "zod/locales";
import type { $ZodRawIssue } from "zod/v4/core";

function customError(iss: $ZodRawIssue): string | undefined {
    if (iss.code === "invalid_type" && !iss.input) {
        return "Prázdná hodnota";
    }

    if (iss.code === "too_small" && iss.origin === "string") {
        return "Nebyl zadán dostatek znaků";
    }

    if (iss.code === "too_small" && iss.origin === "number") {
        const operator = iss.inclusive ? "≥" : ">";
        return `Hodnota je příliš malá: musí být ${operator} ${iss.minimum}`;
    }
}

z.config({ ...cs(), customError });
